"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHangingIndentCss = void 0;
const getHangingIndentCss = (themeId, indentValue) => {
    return `
      .${themeId} .hanging{
        line-height: 1.6em;
        text-indent: -${indentValue}cm;
        padding-left: ${indentValue}cm;
        orphans: 3; 
        widows: 3;
      }
    `;
};
exports.getHangingIndentCss = getHangingIndentCss;
